module.exports = __webpack_public_path__ + "3de30595ba5d891f0202a3bc99982c02.png";